import {
  PanelContainer,
  SVG,
  useIsDesktop,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {RNSvg} from '@eCommerce/frontend-legacy-shared-library-native/lib/typescript/components/SVG/props';
import {Text, View} from 'native-base';
import React from 'react';

export interface ProfileEmptyStateModuleProps {
  svgIcon: string | RNSvg;
  ctaTitle: string;
  body: string;
  onCTAPress: () => void;
  emptyStateTitle: string;
  emptyStateIcon: string;
  testID?: string;
}

const ProfileEmptyStateModule: React.FC<
  ProfileEmptyStateModuleProps
> = props => {
  const {
    svgIcon,
    ctaTitle,
    body,
    onCTAPress,
    emptyStateTitle,
    emptyStateIcon,
    testID,
  } = props;
  const isDesktop = useIsDesktop();

  return (
    <PanelContainer
      testID={testID}
      contentMaxWidth="100%"
      panelTitle={isDesktop ? '' : emptyStateTitle}
      icon={isDesktop ? '' : emptyStateIcon}
      primaryCTA={{label: ctaTitle, onPress: onCTAPress}}>
      <View px={isDesktop ? 7 : 0} alignItems="center">
        <SVG width={178} height={162} source={svgIcon || ''} />
        <View h={7} />
        <Text
          textAlign="center"
          fontFamily="heading"
          fontWeight="bold"
          fontSize={isDesktop ? '36px' : '18px'}>
          {emptyStateTitle.toUpperCase()}
        </Text>
        <View h={6} />
        <Text
          textAlign="center"
          fontSize={isDesktop ? '18px' : '14px'}
          maxWidth="600px">
          {body}
        </Text>
      </View>
    </PanelContainer>
  );
};

export default ProfileEmptyStateModule;
